import React, {useState, useEffect, useRef} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../components/FormFields/SelectInfinite';
import InputText from '../../components/FormFields/InputText';
import TextArea from '../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import SelectList from '../../components/select/SelectList';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import Toast from '../../components/toast/Toast';
import {appModules, defaultMinValueZero, validDouble} from '../../utils/const';
import {
  getPotentionalRisks,
  editIncurredRisk,
  getRiskFile,
  GetPotentionalRisk,
  getDepartment,
} from '../../services/IncurredEvent/incurredEventApi';
import Swal from 'sweetalert2';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import PreventTransitionPrompt from '../../components/preventTransitionprompt/PreventTransition';
import allowedFileTypes from '../../utils/allowedFileTypes';
import LossModal from "./components/modals/LossModal";
import editImage from "./components/img/edit.svg";
import deleteImage from "./components/img/delete.svg";
import {
  formatNumberInput, parseFormattedNumber, maxDecimalNumber,
  formatNumberForDisplay,
  onDecimalNumberInputChange, testIsGreaterThanMin,
  testValidNumber, handlePasteAndValidate, formatNumber,
} from '../../utils/helpers';
import FileUploadSection from "../../components/FileUploadSection/FileUploadSection";
import {format} from 'date-fns';

const ShowIncurredRisk = ({defaultData}) => {
  const lang = getLanguage();
  const [disabled, setDisabled] = useState();
  const [potentionalRisks, setPotentionalRisks] = useState([]);
  const [deleteFiles, setDeleteFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const [userResponsibleLogin,setUserResponsibleLogin] = useState();
  const [lossModalOpen,setLossModalOpen] = useState(false);
  const [isEdit,setIsEdit] = useState(false);
  const [disableSubprocess, setDisableSubProcess] = useState(false);
  const [disableSubCause, setDisableSubCause] = useState(true);
  const [disableRiskCause, setDisableRiskCause] = useState(true);
  const [disableSubCategory, setDisableSubCategory] = useState(true);
  const [lossData, setLossData] = useState(
      defaultData?.riskExpenseDTO.length > 0
          ? defaultData.riskExpenseDTO.map((item) => ({
            ...item,
            lossReason: {
              value: item.lossReason.id,
              label: item.lossReason.name,
            },
          }))
          : []
  );
  const [currentID,setCurrentID] = useState();
  const [yesNoOptions,setYesNoOptions] = useState(  lang === 'eng'
      ? [{value: true, label: 'Yes'},{value:false,label:'No'}]
      : [{value: true, label: 'Da'},{value:false,label:'Ne'}])
  const [defaultFiles, setDefaultFiles] = useState(defaultData?.files);
  const [riskEstimation, setRiskEstimation] = useState(
    defaultData.riskEstimationId
  );
  const userDepartment = useDepartmentContext();
  const [deletedLossIds, setDeletedLossIds] = useState([]);
  const [schema, setSchema] = useState(
    yup.object().shape({
      riskType: yup.object().nullable().required(t('message.fieldRequired')),
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(150, t('message.max', {max: 150})),
      description: yup
        .string()
        .trim()
        .max(2048, t('message.max2048'))
        .required(t('message.fieldRequired')),
      harmfulEventDescription: yup
        .string()
        .trim()
        .max(2048, t('message.max2048'))
        .required(t('message.fieldRequired')),
      riskCauseId: yup.object().nullable().required(t('message.fieldRequired')),
      riskSubCauseId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      departmentStakeholderId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskCategoryId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskSubCategory: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      userResponsibleId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      estimatedGrossLost: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
          .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
           return testIsGreaterThanMin(value,defaultMinValueZero);
          })
          .test('is-valid-number', t('message.mustBeNumber'), (value) => {
            return testValidNumber(value,true);
          }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        .typeError(t('message.onlyDecimalNumbers')),
      process: yup.object().nullable().required(t('message.fieldRequired')),
      subprocessId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      businessLineId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      creditRiskRelated: yup.object().nullable().required(t('message.fieldRequired')),
      // riskMitigationModeName: yup.object().nullable().required(t('message.fieldRequired')),
      typeGainLossId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      // methodologyId: yup
      //   .object()
      //   .nullable()
      //   .required(t('message.fieldRequired')),
      comment: yup.string().trim().max(2048, t('message.max2048')),
      departmentSourceId: yup
          .object()
          .nullable()
          .required(t('message.fieldRequired')),
      riskOccurrenceDiscoveredAt: yup
        .date()
        .nullable()
        .required(t('message.fieldRequired')),
      harmfulOperationalRiskOccurrenceDate: yup
        .date()
        .nullable()
        .required(t('message.fieldRequired')),
      keyIndicatorValue: yup
        .string()
        .trim()
        .when('keyIndicatorId', {
          is: (val) => (val?.escalationCalculationType !== 'COUNTER' && val?.escalationCalculationType !== undefined),
          then: (schema) =>
            schema
              .required(t('message.fieldRequired'))
              .matches(validDouble, t('message.onlyDecimalNumbersMinZero'))
              .typeError(t('message.onlyDecimalNumbersMinZero')),
          otherwise: (schema) => schema.nullable(),
        }),
      riskMitigationModeName: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      lossChargedInsurance: yup.string().when('netLoss', {
        is: (value) => parseFormattedNumber(value) > 0,
        then: yup
          .string()
          .required(t('message.fieldRequired'))
          .test(
            'is-greater-than-min',
            t('message.minValue', {min: defaultMinValueZero}),
            (value) => testIsGreaterThanMin(value, defaultMinValueZero)
          )
          .test(
            'is-valid-number',
            t('message.mustBeNumber'),
            (value) => testValidNumber(value)
          )
          .test(
            'max-two-decimals',
            t('message.maxTwoDecimals'),
            (value) => maxDecimalNumber(value)
          ),
        otherwise: yup.string().nullable(),
      }),
      lossChargedOther: yup.string().when('netLoss', {
        is: (value) => parseFormattedNumber(value) > 0,
        then: yup
          .string()
          .required(t('message.fieldRequired'))
          .test(
            'is-greater-than-min',
            t('message.minValue', {min: defaultMinValueZero}),
            (value) => testIsGreaterThanMin(value, defaultMinValueZero)
          )
          .test(
            'is-valid-number',
            t('message.mustBeNumber'),
            (value) => testValidNumber(value)
          )
          .test(
            'max-two-decimals',
            t('message.maxTwoDecimals'),
            (value) => maxDecimalNumber(value)
          ),
        otherwise: yup.string().nullable(),
      }),
    })
  );

  const fetchPotentionalRisks = async () => {
    try {
      const {data} = await getPotentionalRisks();
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    fetchPotentionalRisks().then((r) => {
      let options = [];
      r.forEach((item) => {
        options.push({
          value: item.id,
          label: item.title,
        });
      });
      setPotentionalRisks(options);
    });
    window.location.pathname.includes('edit')
      ? setDisabled(false)
      : setDisabled(true);
  }, []);

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      riskCategoryId: defaultData?.riskCategoryId
        ? {
          value: defaultData.riskCategoryId,
          label:
            lang === 'mne'
              ? defaultData.riskCategoryName
              : defaultData.riskCategoryNameEn,
        }
        : null,

      riskSubCategory: defaultData?.subcategoryId
        ? {
          value: defaultData.subcategoryId,
          label:
            lang === 'mne'
              ? defaultData.subcategoryName
              : defaultData.subcategoryNameEn,
        }
        : null,

      riskCauseId: defaultData?.riskCauseId
        ? {
          value: defaultData.riskCauseId,
          label:
            lang === 'mne'
              ? defaultData.riskCauseName
              : defaultData.riskCauseNameEn,
        }
        : null,

      riskSubCauseId: defaultData?.riskSubCauseId
        ? {
          value: defaultData.riskSubCauseId,
          label:
            lang === 'mne'
              ? defaultData.riskSubCauseName
              : defaultData.riskSubCauseNameEn,
        }
        : null,
    },
  });

  const {handleSubmit, watch,reset, trigger, setValue} = methods;
  const watchRiskType = watch('riskType');
  const watchProcess = watch('process');
  const watchRiskCause = watch('riskCauseId');
  const watchDepartmentSourceId = watch('departmentSourceId');
  const prevProcessRef = useRef(null);
  const prevCauseIdRef = useRef(defaultData?.riskCauseId ?? null);
  const prevCategoryIdRef = useRef(defaultData?.riskCategoryId ?? null);
  const prevSubCategoryIdRef = useRef(defaultData?.subcategoryId ?? null);
  const isInitialMountRef = useRef(true);
  const watchRiskCategory = watch('riskCategoryId');
  const watchKeyRiskIndicator = watch('keyIndicatorId');
  const watchRiskSubCategory = watch('riskSubCategory');
  useEffect(() => {
    if (watchRiskType?.value !== undefined) {
      if (watchRiskType?.value !== defaultData.potentialRiskId) {
        const fetchPotentialRiskData = async () => {
          try {
            const {data} = await GetPotentionalRisk(watchRiskType?.value);
            setRiskEstimation(data[0].riskEstimationId);
          } catch (e) {
            // console.log(e);
          }
        };
        fetchPotentialRiskData();
      }
    }
  }, [watchRiskType]);

  const [renderAfter, setRenderAfter] = useState(0);

  useEffect(() => {
    const newProcessId = watchProcess?.value ?? null;
    const prevProcessId = prevProcessRef.current;
    setRenderAfter(renderAfter + 1);
    if (watchProcess && !window.location.pathname.includes('edit')) {
      setDisableSubProcess(true);
    }
    if (watchProcess && window.location.pathname.includes('edit')) {
      if (renderAfter >= 3) {
        setDisableSubProcess(false)
        setValue('subprocessId', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
      }
    }
    if (watchProcess === null) {
      setDisableSubProcess(true)
      setValue('subprocessId', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
    if (watchProcess !== null && prevProcessId !== null && prevProcessId !== newProcessId) {
      setValue('subprocessId', null, { shouldValidate: false, shouldDirty: true });
      setDisableSubProcess(false);
    }
    prevProcessRef.current = newProcessId;
  }, [watchProcess]);

  useEffect(() => {
    const newCategoryId = watchRiskCategory?.value ?? null;
    const prevCategoryId = prevCategoryIdRef.current;

    if (disabled) {
      prevCategoryIdRef.current = newCategoryId;
      return;
    }
    if (isInitialMountRef.current) {
      prevCategoryIdRef.current = newCategoryId;
      return;
    }
if (newCategoryId){
  setDisableSubCategory(false)
}
    if (
      prevCategoryId !== null &&
      prevCategoryId !== newCategoryId
    ) {
      setDisableSubCategory(true);
      setDisableRiskCause(true);
      setDisableSubCause(true);
      setValue('riskSubCategory', '', {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskCauseId', '', {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskSubCauseId', '', {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
    if (
      newCategoryId !== null &&
      prevCategoryId !== newCategoryId
    ) {
      setDisableSubCategory(false);
      setDisableRiskCause(true);
      setDisableSubCause(true);
      setValue('riskSubCategory', '', {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskCauseId', '', {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskSubCauseId', '', {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
    if (
      newCategoryId !== null &&
      prevCategoryId !== null &&
      prevCategoryId !== newCategoryId
    ) {
      setDisableSubCategory(false);
      setDisableRiskCause(true);
      setDisableSubCause(true);


      setValue('riskSubCategory', '', {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskCauseId', '', {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskSubCauseId', '', {
        shouldValidate: false,
        shouldDirty: true,
      });
    }

    prevCategoryIdRef.current = newCategoryId;
  }, [watchRiskCategory, disabled, setValue]);

  useEffect(() => {
    const newSubCategoryId = watchRiskSubCategory?.value ?? null;
    const prevSubCategoryId = prevSubCategoryIdRef.current;

    if (disabled) {
      prevSubCategoryIdRef.current = newSubCategoryId;
      return;
    }
    if (isInitialMountRef.current) {
      prevSubCategoryIdRef.current = newSubCategoryId;
      return;
    }
    if (!newSubCategoryId) {
      setDisableRiskCause(true);
      setDisableSubCause(true);

      setValue('riskCauseId', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
      setValue('riskSubCauseId', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
    if (!newSubCategoryId &&  prevSubCategoryId !== newSubCategoryId) {
      setDisableRiskCause(true);
      setDisableSubCause(true);

      setValue('riskCauseId', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskSubCauseId', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
    if (!prevSubCategoryId &&  prevSubCategoryId !== newSubCategoryId) {
      setDisableRiskCause(true);
      setDisableSubCause(true);

      setValue('riskCauseId', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskSubCauseId', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
    if (
      newSubCategoryId !== null &&
      prevSubCategoryId !== null &&
      prevSubCategoryId !== newSubCategoryId
    ) {
      setDisableRiskCause(false);
      setDisableSubCause(true);

      setValue('riskCauseId', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskSubCauseId', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
    }

    prevSubCategoryIdRef.current = newSubCategoryId;
  }, [watchRiskSubCategory, disabled, setValue]);
  useEffect(() => {
    const newCauseId = watchRiskCause?.value ?? null;
    const prevCauseId = prevCauseIdRef.current;

    if (disabled) {
      prevCauseIdRef.current = newCauseId;
      return;
    }
    if (isInitialMountRef.current) {
      prevCauseIdRef.current = newCauseId;
      return;
    }
    if (newCauseId) {
      setDisableSubCause(false);
    }
    if(newCauseId !== null && newCauseId !== prevCauseId){
      setDisableSubCause(false);
      setValue('riskSubCauseId', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
    if(prevCauseId !== null && newCauseId !== prevCauseId){
      setDisableSubCause(true);
      setValue('riskSubCauseId', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
     if (
      newCauseId !== null &&
      prevCauseId !== null &&
      prevCauseId !== newCauseId
    ) {
      setValue('riskSubCauseId', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setDisableSubCause(false);
    }
    prevCauseIdRef.current = newCauseId;
  }, [watchRiskCause, disabled, setValue]);
  useEffect(() => {
    if (disabled) return;

    if (watchRiskCategory?.value && watchRiskSubCategory?.value) {
      setDisableRiskCause(false);
    } else {
      setDisableRiskCause(true);
      setDisableSubCause(true);


      setValue('riskCauseId', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
      setValue('riskSubCauseId', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRiskCategory, watchRiskSubCategory, disabled, setValue]);
  useEffect(() => {
    isInitialMountRef.current = false;
  }, []);
  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const formatDateOfEventDiscovered =
      format(new Date(data?.riskOccurrenceDiscoveredAt), 'yyyy-MM-dd') +
      'T' +
      format(new Date(data?.riskOccurrenceDiscoveredAt), 'hh:mm:ss');
    const formathHarmfulOperationalRiskOccurrenceDate =
      format(new Date(data?.harmfulOperationalRiskOccurrenceDate), "yyyy-MM-dd'T'HH:mm:ss")
    const payload = {
      id: defaultData.id,
      riskTypeId: 2,
      potentialRiskId: data.riskType.value,
      title: data.title,
      description: data.description,
      harmfulEventDescription: data.harmfulEventDescription,
      typeGainLossId: data.typeGainLossId.value,
      // methodologyId: data.methodologyId.value,
      riskCauseId: data.riskCauseId.value,
      riskSubCauseId: data.riskSubCauseId.value,
      departmentStakeholderId: data.departmentStakeholderId.value,
      riskCategoryId: data.riskCategoryId.value,
      subcategoryId: data.riskSubCategory?.value,
      userResponsibleId: data.userResponsibleId.value,
      userResponsibleLogin: userResponsibleLogin,
      userCreatedId: defaultData.userCreatedId,
      userCreatedLogin: defaultData.userCreatedLogin,
      userInChargeId: defaultData.userInChargeId,
      userInChargeLogin: defaultData.userInChargeLogin,
      riskStatusId: defaultData.riskStatusId,
      subprocessId: data.subprocessId.value,
      processId: data.process.value,
      estimatedGrossLost: parseFormattedNumber(data.estimatedGrossLost),
      comment: data.comment,
      businessLineId: data.businessLineId.value,
      creditRiskRelated: data.creditRiskRelated?.value,
      riskMitigationModeId: data?.riskMitigationModeName?.value,
      riskMitigationModeName: data?.riskMitigationModeName?.label,
      applicationDate: new Date(defaultData.applicationDate),
      deleteFiles: deleteFiles,
      riskEstimationId: riskEstimation,
      departmentSourceId: data.departmentSourceId.value,
      riskExpenseDTO: lossData.length > 0
        ? lossData.map((item) => ({
          ...(typeof item?.id === 'number' ? { id: item?.id } : {}),
          lossReason: {
            id: item?.lossReason.value,
            name: item?.lossReason.label,
          },
          netLoss: parseFormattedNumber(item?.netLoss),
          lossDate: item?.lossDate,
        }))
        : [],
      riskOccurrenceDiscoveredAt: formatDateOfEventDiscovered,
      harmfulOperationalRiskOccurrenceDate: formathHarmfulOperationalRiskOccurrenceDate,
      keyIndicatorId: data?.keyIndicatorId?.value,
      keyIndicatorValue: data?.keyIndicatorValue,
      grossLoss: parseFormattedNumber(data?.grossLoss),
      lossChargedInsurance: parseFormattedNumber(data?.lossChargedInsurance),
      lossChargedOther: parseFormattedNumber(data?.lossChargedOther),
      netLoss: parseFormattedNumber(data?.netLossNumber),
    };

    try {
      const response = await editIncurredRisk(payload, files);
      if (response.status === 200) {
        await Toast.fire({
          title: t('message.updateSuccess2', {
            entity: t('common.incurred-risk'),
          }),
          icon: 'success',
        });
      }
      window.location = `/incurred-risk/${parseInt(defaultData.id)}`;
    } catch (err) {
      if (err.response.data.code === 'risk-exists') {
        Swal.fire({
          text:
            lang === 'eng'
              ? err.response.data.description
              : t('message.addRiskErrorExists'),
          icon: 'error',
        });
      } else {
        Toast.fire({
          title: t('message.errorApi'),
          icon: 'error',
        });
      }
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    window.location = `/incurred-risk/${defaultData.id}`;
  };
  const clearFetchedFile = (id) => {
    let children = defaultFiles.filter((file) => file.id !== id);
    let deleteFilesIds = [];
    deleteFilesIds.push(id);
    setDefaultFiles([...children]);
    setDeleteFiles(deleteFilesIds);
  };

  const deleteConto = (id) => {
    setLossModalOpen(false);

    const itemToDelete = lossData.find(
      (item) => item.id === id || item.tempId === id
    );

    if (itemToDelete && typeof itemToDelete?.id === 'number') {
      setDeletedLossIds((prev) => [...prev, itemToDelete.id]);
    }

    setLossData((prevLossData) =>
      prevLossData.filter(
        (item) => item.id !== id && item.tempId !== id
      )
    );
  };
  useEffect(() => {
    if (watchDepartmentSourceId) {
      const depratmentObject = async () => {
        try {
          const {data} = await getDepartment(watchDepartmentSourceId.value);
          setUserResponsibleLogin(data[0]?.userResponsibleLogin)
          setValue('userResponsibleId', {
            value: data[0].userResponsibleId,
            label:
              data[0].userResponsibleFirstName +
              ' ' +
              data[0].userResponsibleLastName,
          });
        } catch {}
      };
      depratmentObject();
    }
  }, [watchDepartmentSourceId]);

  useEffect(() => {
    const index = lossData.findIndex((loss) => loss.id === currentID);
    lossData.forEach((loss, index) => {
      setValue(`lossData.${index}.account`, loss?.lossReason);
    });
    if (index !== -1) {
      const selectedLoss = lossData[index];
      setValue(`lossData.${index}.account`, selectedLoss?.lossReason);
      setValue(`lossData.${index}.account`, selectedLoss?.lossReason);
    }
  },[lossData])
  const sum = lossData.reduce((acc, item) => {
    const value = parseFormattedNumber(item?.netLoss) || 0;
    return acc + value;
  }, 0);
  const netLossNumberValue = sum -
    parseFormattedNumber(watch('lossChargedInsurance')) -
    parseFormattedNumber(watch('lossChargedOther'))

  const handleChange = (event) => {
    event.target.value = formatNumberInput(event.target.value);
  };
    return (
        <>
            {defaultData !== undefined && (
                <>
                    <PreventTransitionPrompt when={!disabled} />
                    <div className="main-form mt-4">
                        <FormProvider {...methods}>
                            <form onSubmit={handleSubmit(submitForm)}>
                                <Row className="field-group-title">
                                    <Col className="col-6 col-xl-3">
                                        {t('incurred-risk.mainData')}
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col className="col-6 col-xl-3">
                                        <label className="label-incurred">
                                            {t('incurred-risk.potentionalRisk')}
                                        </label>
                                        <SelectInfinite
                                            api="/risks?riskTypeId.equals=1&riskStatusId.in=1,2,3"
                                            name="riskType"
                                            placeholder={t(
                                                'incurred-risk.placeholder.potentionalRisk'
                                            )}
                                            labelKey={'title'}
                                            className="select"
                                            isClearable
                                            queryKeys={'title.contains'}
                                            defaultValue={
                                                defaultData.potentialRiskId !== null
                                                    ? {
                                                        value: defaultData.potentialRiskId,
                                                        label: defaultData.potentialRiskTitle,
                                                    }
                                                    : null
                                            }
                                            isDisabled={disabled}
                                            isSelectWithId={true}
                                        />
                                        <label className="label-incurred">
                                            {t('incurred-risk.title')}
                                        </label>
                                        <InputText
                                            type="text"
                                            name="title"
                                            className="form-control input-field"
                                            placeholder={t('incurred-risk.placeholder.title')}
                                            disabled={disabled}
                                            defaultValue={defaultData?.title}
                                        />
                                      <label className="label-incurred">
                                        {t('incurred-risk.keyIndicatorId')}
                                      </label>
                                      <span className="optional register">
                  {t('common.optional')}
                </span>
                                      <SelectInfinite
                                        api="/key-indicators?activate.equals=true"
                                        isKeyIndicator={true}
                                        name="keyIndicatorId"
                                        placeholder={t('incurred-risk.placeholder.keyIndicatorId')}
                                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                                        className="select"
                                        isClearable
                                        queryKeys={lang === 'mne' ? 'indicatorName.contains' : 'indicatorNameEn.contains'}
                                        isDisabled={defaultData?.keyIndicatorId ? (
                                          disabled || defaultData?.riskStatusId !== 1)
                                          :  disabled}
                                        defaultValue={defaultData?.keyIndicatorId ? {
                                          value: defaultData?.keyIndicatorId,
                                          label:
                                            lang === 'mne'
                                              ? defaultData?.keyIndicatorName
                                              : defaultData?.keyIndicatorNameEn,
                                          escalationCalculationType: defaultData?.escalationCalculationType
                                        } : null}
                                      />
                                    </Col>
                                    <Col className="col-6 col-xl-3">
                                        <label className="label-incurred">
                                            {t('incurred-risk.descriptionRisk')}
                                        </label>
                                        <TextArea
                                            name="description"
                                            className={`form-control text-area `}
                                            placeholder={t('incurred-risk.placeholder.descriptionRisk')}
                                            disabled={disabled}
                                            defaultValue={defaultData?.description}
                                        />
                                      {(watchKeyRiskIndicator?.escalationCalculationType !== 'COUNTER' && watchKeyRiskIndicator !== null) && <>
                                        <label className="label pt-2" htmlFor="value">
                                          {t('Pages.ViewKeyRiskIndicator.value')}
                                        </label>
                                        <InputText
                                          name="keyIndicatorValue"
                                          type="number"
                                          className="form-control"
                                          placeholder={t("Pages.ViewKeyRiskIndicator.placeholderValue")}
                                          disabled={disabled}
                                          defaultValue={defaultData?.keyIndicatorValue}
                                        />
                                      </>}
                                    </Col>
                                  <Col className="col-6 col-xl-3">
                                    <label className="label-incurred">
                                      {t('incurred-risk.description')}
                                    </label>
                                    <TextArea
                                      name="harmfulEventDescription"
                                      className={`form-control text-area `}
                                      placeholder={t('incurred-risk.placeholder.description')}
                                      disabled={disabled}
                                      defaultValue={defaultData?.harmfulEventDescription}
                                    />
                                  </Col>
                                </Row>
                                <Row className="mt-5 field-group-title">
                                    <Col className="col-6 col-xl-3">
                                        {t('incurred-risk.additionalInformation')}
                                    </Col>
                                </Row>

                <Row className="mt-2">
                  <Col className="col-3 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.category')}
                    </label>
                    <SelectInfinite
                      api="risk-categories?active.equals=true"
                      name="riskCategoryId"
                      placeholder={t('incurred-risk.placeholder.category')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.riskSubCategory')}
                    </label>
                    <SelectInfinite
                      api={
                        watchRiskCategory?.value !== undefined
                          ? `/risk-subcategories?riskCategoryId.equals=${watchRiskCategory?.value}&active.equals=true`
                          : `/risk-subcategories?riskCategoryId.equals=1&active.equals=true`
                      }
                      name='riskSubCategory'
                      placeholder={t('incurred-risk.placeholder.riskSubCategory')}
                      key={`riskSubCategory-${watchRiskCategory?.value || 'empty'}`}
                      className='select'
                      isDisabled={disabled || disableSubCategory}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.riskCauses')}
                    </label>
                    <SelectInfinite
                      key={`riskCause-${watchRiskSubCategory?.value || 'empty'}`}
                      api={
                        watchRiskSubCategory?.value
                          ? `risk-causes?riskSubCategoryId.equals=${watchRiskSubCategory.value}`
                          : 'risk-causes'
                      }
                      name="riskCauseId"
                      placeholder={t('incurred-risk.placeholder.riskCauses')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled || disableRiskCause}
                      ref={prevCauseIdRef}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.subCauses')}
                    </label>
                    <SelectInfinite
                      api={
                        watchRiskCause?.value !== undefined
                          ? `/risk-sub-causes?riskCauseId.equals=${watchRiskCause?.value}&riskSubCategoryId.equals=${watchRiskSubCategory?.value}&active.equals=true`
                          : `/risk-sub-causes?riskCauseId.equals=1&active.equals=true`
                      }
                      name='riskSubCauseId'
                      placeholder={t('incurred-risk.placeholder.subCauses')}
                      key={watchRiskCause?.value}
                      className='select'
                      isDisabled={disabled || disableSubCause}
                    />
                    <label className="label-litigation">
                      {t('potentialRisk.dateOfEventOccurrence')}
                    </label>
                    <InputDate
                      name="harmfulOperationalRiskOccurrenceDate"
                      defaultValue={(defaultData?.harmfulOperationalRiskOccurrenceDate)}
                      placeholder={t('potentialRisk.placeholder.selectDate')}
                      style={{height: '45px!important', width: '100%'}}
                      isClearable={false}
                      disabled={disabled}
                    />
                  </Col>
                  <Col className="col-3 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.process')}
                    </label>
                    <SelectInfinite
                      api="processes?active.equals=true"
                      name="process"
                      placeholder={t('incurred-risk.placeholder.process')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                      ref={prevProcessRef}
                      defaultValue={
                        defaultData.processId !== null
                          ? {
                              value: defaultData.processId,
                              label:
                                lang === 'mne'
                                  ? defaultData.processName
                                  : defaultData.processNameEn,
                            }
                          : null
                      }
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.subprocess')}
                    </label>
                    <SelectInfinite
                      api={
                        watchProcess?.value !== undefined
                          ? `/subprocesses?processId.equals=${watchProcess?.value}&active.equals=true`
                          : `/subprocesses?processId.equals=1&active.equals=true`
                      }
                      name="subprocessId"
                      placeholder={t('incurred-risk.placeholder.subprocess')}
                      key={watchProcess?.value}
                      className="select"
                      defaultValue={
                        defaultData?.subprocessId
                          ? {
                            value: defaultData.subprocessId,
                            label: lang === 'mne' ? defaultData.subprocessName : defaultData.subprocessNameEn,
                          }
                          : null
                      }
                      isDisabled={disableSubprocess}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.businessLines')}
                    </label>
                    <SelectInfinite
                      api="business-lines"
                      name="businessLineId"
                      placeholder={t('incurred-risk.placeholder.businessLines')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                      defaultValue={
                        defaultData.businessLineId !== null
                          ? {
                            value: defaultData.businessLineId,
                            label:
                              lang === 'mne'
                                ? defaultData.businessLineName
                                : defaultData.businessLineNameEn,
                          }
                          : null
                      }
                    />
                  {/*  <label className="label-incurred">*/}
                  {/*  {t*/}
                  {/*  ('incurred-risk.metodologies')}*/}
                  {/*</label>*/}
                  {/*  <SelectInfinite*/}
                  {/*    api="methodologies"*/}
                  {/*    name="methodologyId"*/}
                  {/*    placeholder={t('incurred-risk.placeholder.metodologies')}*/}
                  {/*    labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                  {/*    className="select"*/}
                  {/*    isDisabled={disabled}*/}
                  {/*    defaultValue={{*/}
                  {/*      value: defaultData.methodologyId,*/}
                  {/*      label:*/}
                  {/*        lang === 'mne'*/}
                  {/*          ? defaultData.methodologyName*/}
                  {/*          : defaultData.methodologyNameEn,*/}
                  {/*    }}*/}
                  {/*  />*/}
                    <label className="label-incurred">
                      {t('potentialRisk.riskOccurrenceDiscoveredAt')}
                    </label>
                    <InputDate
                      name="riskOccurrenceDiscoveredAt"
                      defaultValue={(defaultData?.riskOccurrenceDiscoveredAt)}
                      placeholder={t('potentialRisk.placeholder.selectDate')}
                      style={{height: '65px!important'}}
                      disabled={disabled}
                      isClearable={false}
                      minDate={watch('harmfulOperationalRiskOccurrenceDate')}
                    />
                  </Col>
                  <Col className="col-3 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.typeGainLoss')}
                    </label>
                    <SelectInfinite
                      api="type-gain-losses"
                      name="typeGainLossId"
                      placeholder={t('incurred-risk.placeholder.typeGainLoss')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                      defaultValue={
                        defaultData.typeGainLossId !== null
                          ? {
                            value: defaultData.typeGainLossId,
                            label:
                              lang === 'mne'
                                ? defaultData.typeGainLossName
                                : defaultData.typeGainLossNameEn,
                          }
                          : null
                      }
                    />
                    <label className="label-incurred">
                    {t('incurred-risk.isEventConnected')}
                  </label>
                    <SelectList
                      name="creditRiskRelated"
                      className="select"
                      options={yesNoOptions}
                      placeholder={t('incurred-risk.isEventConnectedPlaceholder')}
                      isClearable={false}
                      isDisabled={disabled}
                      defaultValue={
                        defaultData.creditRiskRelated !== null
                          ? {
                            value: defaultData.creditRiskRelated,
                            label:
                              lang === 'mne'
                                ? defaultData.creditRiskRelated === true ? 'Da' : 'Ne'
                                : defaultData.creditRiskRelated === true ? 'Yes' : 'No',
                          }
                          : null
                      }
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.estimatedGrossLoss')}
                    </label>
                    <InputText
                      type="text"
                      name="estimatedGrossLost"
                      className="form-control input-field"
                      placeholder={t(
                        'incurred-risk.placeholder.estimatedGrossLoss'
                      )}
                      disabled={disabled}
                      defaultValue={defaultData.estimatedGrossLost !== null ? formatNumberInput(formatNumberForDisplay(defaultData.estimatedGrossLost)) : ''}
                      onChange={(e) => onDecimalNumberInputChange(e,setValue,"estimatedGrossLost")}
                      onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'estimatedGrossLost')}
                    />
                    <label className="label-incurred">
                      {t('mitigation-measures.method')}
                    </label>
                    <SelectInfinite
                      api="/risk-mitigation-modes"
                      name="riskMitigationModeName"
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      placeholder={t('placeholder.riskMitigrationMethod')}
                      isDisabled={disabled}
                      defaultValue={defaultData.riskMitigationModeName ? {label: defaultData.riskMitigationModeName,
                        value: defaultData.riskMitigationModeId} : null}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.attachFile')}
                    </label>
                    <FileUploadSection
                      disabled={disabled}
                      allowedFileTypes={allowedFileTypes}
                      fetchedFiles={defaultFiles}
                      onDeleteFetchedFile={clearFetchedFile}
                      onNewFilesChange={(newFiles) => setFiles(newFiles)}
                      onFileDownload={getRiskFile}
                    />
                  </Col>
                  <Col className="col-3 col-xl-3">
                    {/* prikaz podataka za oj koja je kreirala rizik */}
                    <label className="label-potential-risk">
                      {t('potentialRisk.departmentRisk')}
                    </label>
                    {userDepartment?.length > 1 ? (
                      <SelectInfinite
                        api={`departments/departments-user-in-charge?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                        name="departmentSourceId"
                        placeholder={t(
                          'potentialRisk.placeholder.departmentRisk'
                        )}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        defaultValue={{
                          value: defaultData.departmentSourceId,
                          label:
                            lang === 'mne'
                              ? defaultData.departmentSourceName
                              : defaultData.departmentSourceNameEn,
                        }}
                        isDisabled={disabled}
                      />
                    ) : (
                      <SelectInfinite
                        api={`departments/departments-user-in-charge?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                        name="departmentSourceId"
                        placeholder={t(
                          'potentialRisk.placeholder.departmentRisk'
                        )}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        defaultValue={{
                          value: defaultData.departmentSourceId,
                          label:
                            lang === 'mne'
                              ? defaultData.departmentSourceName
                              : defaultData.departmentSourceNameEn,
                        }}
                        isDisabled={true}
                      />
                    )}
                    <label className="label-incurred">
                      {t('incurred-risk.department')}
                    </label>
                    <SelectInfinite
                      api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                      name="departmentStakeholderId"
                      placeholder={t('incurred-risk.placeholder.department')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                      defaultValue={{
                        value: defaultData.departmentStakeholderId,
                        label:
                          lang === 'mne'
                            ? defaultData.departmentStakeholderName
                            : defaultData.departmentStakeholderNameEn,
                      }}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.userInCharge')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="users"
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value: defaultData.userInChargeId,
                        label:
                          defaultData.userInChargeFirstName +
                          ' ' +
                          defaultData.userInChargeLastName,
                      }}
                    />
                    {/* odgovorno lice */}
                    {userDepartment?.length === 1 ? (
                      <>
                        <label className="label-potential-risk">
                          {t('incurred-risk.responsibleUser')}
                        </label>
                        <SelectInfinite
                          api="users"
                          name="userResponsibleId"
                          labelKey="firstName"
                          placeholder={t(
                            'incurred-risk.placeholder.responsibleUser'
                          )}
                          className="select"
                          isDisabled={true}
                          defaultValue={{
                            value:
                              userDepartment[0]?.id !== undefined
                                ? userDepartment[0]?.userResponsibleId
                                : '',
                            label:
                              userDepartment[0]?.id !== undefined
                                ? userDepartment[0]?.userResponsibleFirstName +
                                ' ' +
                                userDepartment[0]?.userResponsibleLastName
                                : '',
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <label className="label-potential-risk">
                          {t('incurred-risk.responsibleUser')}
                        </label>
                        <SelectInfinite
                          api="users"
                          name="userResponsibleId"
                          labelKey="firstName"
                          placeholder={t(
                            'incurred-risk.placeholder.responsibleUser'
                          )}
                          className="select"
                          isDisabled={true}
                        />
                      </>
                    )}
                    <label className="label-incurred">
                      {t('incurred-risk.additionalComment')}
                    </label>
                    <span className="optional register">
                      {t('common.optional')}
                    </span>
                    <TextArea
                      name="comment"
                      className={`form-control text-area `}
                      placeholder={t(
                        'incurred-risk.placeholder.additionalComment'
                      )}
                      disabled={disabled}
                      defaultValue={defaultData?.comment}
                    />
                  </Col>
                </Row>
                <Row>
                <Col className="col-3 col-xl-3">
                <label className="label-incurred">
                  {t('codebook.addIncurredLoss')}
                </label>
                <span className="optional register">
                       {t('common.optional')}
                    </span>
                <p className={'file-input'} style={{marginBottom: '-8px',
                  backgroundColor: disabled ? 'hsl(0, 0%, 95%)' : '#d3e1f5'
                }} onClick={() => {
                  if(!disabled) {
                    setIsEdit(false)
                    setLossModalOpen(true)
                  }
                }}></p>
                <LossModal
                    open={lossModalOpen}
                    setLossData={setLossData}
                    lossData={lossData}
                    id={currentID}
                    isEdit={isEdit}
                    riskId={defaultData?.id}
                    isOpen={(e) => setLossModalOpen(e)}
                />
                </Col>
                </Row>
                <Row>
                {lossData.map((item,index) => (
                    <>
                      <Col className="col-3 col-xl-3">
                      <label className="label-incurred">
                          {t('codebook.codebook')}
                      </label>
                        <SelectInfinite
                            api="/loss-reasons"
                            name={`lossData.${index}.account`}
                            placeholder={t('incurred-risk.placeholder.category')}
                            labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                            className="select"
                            isDisabled={true}
                            defaultValue={item?.lossReason}
                        />
                      </Col>
                      <Col className="col-3 col-xl-3" style={{marginRight: '5px'}}>
                      <label className="label-incurred">
                          {t('codebook.lossDate')}
                        </label>
                        <InputDate
                            name="lossDate"
                            selected={new Date(item?.lossDate)}
                            placeholder={t('codebook.lossDatePlaceholder')}
                            style={{height: '65px!important'}}
                            forceSelected={true}
                            disabled={true}
                            isClearable={false}
                        />
                      </Col>
                      <Col className="col-3 col-xl-3" style={{marginRight: '5px'}}>
                      <label className="label-incurred">
                          {t('codebook.loss')}
                        </label>
                        <InputText
                            type="text"
                            name="netLoss"
                            className="form-control input-field"
                            placeholder={t('incurred-risk.placeholder.title')}
                            disabled={true}
                            value={item?.netLoss ? formatNumberInput(formatNumberForDisplay(item?.netLoss)) : ''}
                        />
                      </Col>
                      {!disabled &&  <><img style={{marginTop: '30px',marginLeft: '5px',cursor: 'pointer'}} onClick={() => {
                        setLossModalOpen(true);
                        setCurrentID(item.id ?? item.tempId);
                        setIsEdit(true);
                      }} src={editImage} alt={'edit'}/>
                        <img style={{marginTop: '30px',marginLeft: '5px',cursor: 'pointer'}} onClick={() => deleteConto(item?.id ?? item?.tempId)} src={deleteImage} alt={'delete'}/>
                      </>}
                    </>
                ))}
                </Row>
                              <Row className="pb-5 pt-2">
                                {lossData?.length > 0 &&
                                  <>
                                    <Col className="col-3" >
                                      <label className="label-litigation">
                                        {t('litigation.grossLoss')}
                                      </label>
                                      <InputText
                                        type="text"
                                        name="grossLoss"
                                        className="form-control input-field"
                                        placeholder={t('litigation.placeholder.placeholder.grossLoss')}
                                        disabled={true}
                                        value={formatNumber(sum)}
                                      />
                                    </Col>
                                    <Col className="col-3" >
                                      <label className="label-litigation">
                                        {t('litigation.lossChargedInsurance')}
                                      </label>
                                      <InputText
                                        type="text"
                                        name="lossChargedInsurance"
                                        onChange={handleChange}
                                        defaultValue={formatNumberInput(formatNumberForDisplay(defaultData?.lossChargedInsurance))}
                                        className="form-control input-field"
                                        placeholder={t('litigation.placeholder.placeholder.lossChargedInsurance')}
                                        disabled={disabled}
                                      />
                                    </Col>
                                    <Col className="col-3" >
                                      <label className="label-litigation">
                                        {t('litigation.lossChargedOther')}
                                      </label>
                                      <InputText
                                        type="text"
                                        name="lossChargedOther"
                                        onChange={handleChange}
                                        defaultValue={formatNumberInput(formatNumberForDisplay(defaultData?.lossChargedOther))}
                                        className="form-control input-field"
                                        placeholder={t('litigation.placeholder.placeholder.lossChargedOther')}
                                        disabled={disabled}
                                      />
                                    </Col>
                                    <Col className="col-3" >
                                      <label className="label-litigation">
                                        {t('litigation.netLossNumber')}
                                      </label>
                                      <InputText
                                        type="text"
                                        name="netLossNumber"
                                        className="form-control input-field"
                                        placeholder={t('litigation.placeholder.placeholder.lossChargedOther')}
                                        disabled={true}
                                        defaultValue={defaultData?.netLoss}
                                        value={formatNumber(netLossNumberValue)}
                                      />
                                    </Col>
                                  </>}
                              </Row>
                <Row className="mt-2">
                  <Col className="col-6 col-xl-3">
                  </Col>
                  <Col className="col-6 col-xl-3">
                  </Col>
                </Row>
                <Row className="mt-5 field-group-title">
                  <Col className="col-6 col-xl-3">
                    {t('litigation.systemAddedInformation')}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.id')}
                    </label>
                    <InputText
                      type="text"
                      name="id"
                      className="form-control input-field"
                      disabled={true}
                      defaultValue={defaultData?.id}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.date')}
                    </label>
                    <InputDate
                      name="creationDate"
                      className="form-control input-field"
                      selected={new Date(defaultData.applicationDate)}
                      disabled={true}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.status')}
                    </label>
                    <SelectInfinite
                      api="risk-statuses"
                      name="riskStatus"
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value: defaultData.riskStatusId,
                        label:
                          lang === 'mne'
                            ? defaultData.riskStatusName
                            : defaultData.riskStatusNameEn,
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                </Row>
                <Row className="mt-3 form-footer">
                  {!disabled && (
                    <>
                      <button
                        className="secondary-btn"
                        type="reset"
                        onClick={handleCancel}
                      >
                        {t('buttons.cancel')}
                      </button>
                      <button className="primary-btn" type="submit">
                        {t('buttons.save')}
                      </button>
                    </>
                  )}
                </Row>
              </form>
            </FormProvider>
          </div>
        </>
      )}
    </>
  );
};

export default ShowIncurredRisk;
